import React, { useEffect, useRef } from "react";
import { ReturnQRCodeReader } from "./ReturnQRCodeReader";

const QR_TIMEOUT_MS = 30000;

export function ScanQrCode({ onSuccess, onError, t }) {
  const resolved = useRef(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!resolved.current) {
        resolved.current = true;
        onError();
      }
    }, QR_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [onError]);

  function handleSuccess(qrText) {
    if (resolved.current) return;
    resolved.current = true;
    onSuccess(qrText);
  }

  function handleError() {
    if (resolved.current) return;
    resolved.current = true;
    if (onError) {
      onError();
    }
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "2rem",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginBottom: "24px" }}>
        <p className="return-subtitle" style={{ margin: 0 }}>
          {t("keylessReturnScanInstruction")}
        </p>
      </div>

      <div
        style={{
          width: "100%",
          minHeight: "400px",
          borderRadius: "16px",
          overflow: "hidden",
          backgroundColor: "#E2E5E9",
        }}
      >
        <ReturnQRCodeReader
          handleSuccess={handleSuccess}
          handleError={handleError}
          height="400px"
        />
      </div>

    </div>
  );
}
